export default class RadioController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-radio')

    const modifier = this._$attrs.modifier

    if (modifier) {
      this._$attrs.$addClass(`vd-radio--${modifier}`)
    }
  }
}
